import { gql } from '@apollo/client'

/**
 * @deprecated use fragment from here `src/gql/fragments/DfmFeedback.graphql`
 */
export default gql`
    fragment DfmFeedbackDeprecatedSnapshot on ModelViewerConfig {
        camera {
            position
            zoom
            up
            target
        }
        part {
            transparent
            patches {
                color
                hashcode
            }
        }
        rotation
        dfm {
            color
            threshold
            feature
            direction
        }
        annotations {
            position
        }
        crossSection {
            position
            rotation
        }
        pointToPoint {
            customPoints
            selectedPoints {
                index
                type
            }
        }
    }
    fragment dfmFeedbackDeprecated on DfmFeedback {
        id
        isValid
        message
        title
        link
        code
        isPublished
        severity
        sourceType
        isAutoGeneratedDfm
        createdBy {
            displayName
            email
        }
        modelViewerSnapshots {
            id
            snapshot {
                ...DfmFeedbackDeprecatedSnapshot
            }
        }
        createdAt
        deletedAt
    }
`
